import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  arrow: {
    marginLeft: 4,
    width: 16,
    height: 16,
  },
}));
